import React from 'react';
import ReactDOM from 'react-dom';

import App from './app';

import 'app/google-tag-manager';
import 'app/i18n';

ReactDOM.render(<App />, document.getElementById('root'));
